export const validateForm = (formData) => {
  const errors = {};

  const str = (v) => String(v ?? "").trim();

  if (!str(formData?.firstName)) errors.firstName = true;
  if (!str(formData?.lastName)) errors.lastName = true;
  if (!formData?.dateOfBirth) errors.dateOfBirth = true;
  if (!formData?.consentDeclaration) errors.consentDeclaration = true;

  if (!formData?.initialFindings && !formData?.followUpTest) {
    errors.initialOrFollowUp = true;
  }

  if (formData?.otherTherapist) {
    if (!str(formData?.therapistName)) errors.therapistName = true;
    if (!str(formData?.practiceName)) errors.practiceName = true;
    if (!str(formData?.city)) errors.therapistCity = true;
    if (!str(formData?.email)) errors.therapistEmail = true;
  }

  const ts = formData?.testSymptoms || {};
  const bloating = ts.bloating || {};
  const diarrhoea = ts.diarrhoea || {};
  const abdominalPain = ts.abdominalPain || {};
  const others = ts.others || { checked: false, symptoms: [] };

  if (bloating.checked && !str(bloating.minutes)) errors.bloatingMinutes = true;
  if (diarrhoea.checked && !str(diarrhoea.minutes)) errors.diarrhoeaMinutes = true;
  if (abdominalPain.checked && !str(abdominalPain.minutes)) errors.abdominalPainMinutes = true;

  if (others.checked) {
    (others.symptoms || []).forEach((symptom, index) => {
      if (!str(symptom?.description)) errors[`otherSymptomDescription_${index}`] = true;
      if (!str(symptom?.minutes)) errors[`otherSymptomMinutes_${index}`] = true;
      const wc = symptom?.wordCount ?? 0;
      if (wc > 3 || wc < 1) errors[`otherSymptomDescription_${index}`] = true;
    });
  }

  return errors;
};
